import React, { useEffect, useState } from 'react';
import Bounce from 'react-reveal/Bounce';
import Heading from '../Heading';
import { getNonPromoProducts } from '../../api/products';
import useAuth from '../../hooks/useAuth';
import useOrder from '../../hooks/useOrder';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { BsCart2 } from 'react-icons/bs';
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen';

const Products = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const { handleCart } = useOrder();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNonPromo = async () => {
      try {
        const res = await getNonPromoProducts();
        const filtered = res.data?.filter(p => p.quantity > 0) || [];
        const shuffled = filtered.sort(() => 0.5 - Math.random());
        setData(shuffled.slice(0, 12));

      } catch (err) {
        console.error('Error fetching products:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchNonPromo();
  }, []);

  const handleAddToCart = async (productId) => {
    try {
      await handleCart({ _id: productId, quantity: 1 });
      swal('✅ Ajouté', 'Produit ajouté au panier', 'success');
    } catch (err) {
      console.error('Error adding product to cart:', err);
      swal('❌ Erreur', 'Impossible d’ajouter au panier', 'error');
    }
  };

  const renderCard = (product) => (
    <div className="bg-white rounded-xl shadow-md p-4 hover:shadow-lg transition flex flex-col justify-between">
      <div className="w-full h-[230px] bg-gray-100 rounded overflow-hidden flex items-center justify-center mb-3">
        <img
          src={product.image}
          alt={product.name}
          className="max-h-full max-w-full object-contain"
        />
      </div>
      <h2 className="text-lg font-bold truncate">{product.name}</h2>
      <p className="text-paragaia text-xl font-semibold">{product.initialPrice} TND</p>

      <div className="flex flex-col md:flex-row justify-between items-center mt-4 gap-2">
        {user && (
          <button
            className="bg-paragaia text-white px-3 py-2 rounded-md text-sm flex items-center gap-2 hover:bg-[#e8c7d8] w-full md:w-auto"
            onClick={() => handleAddToCart(product._id)}
          >
            <BsCart2 />
            Ajouter
          </button>
        )}
        <button
          className="border border-paragaia text-paragaia px-3 py-2 rounded-md text-sm hover:bg-paragaiaLight w-full md:w-auto"
          onClick={() => {
            localStorage.setItem('selected_product_id', product._id);
            localStorage.setItem('selected_product_promo', product.promoPercentage);
            navigate(`/products/view/${encodeURIComponent(product.name)}`);
          }}
        >
          Voir
        </button>
      </div>
    </div>
  );

  if (loading) return <LoadingScreen />;

  return (
    <section className="max-w-screen-xl mx-auto px-6 py-6 pb-24">
      <Heading title="Produits" />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8 md:gap-10 py-6">
        {data.map((product) => (
          <Bounce left key={product._id}>
            {renderCard(product)}
          </Bounce>
        ))}
      </div>
    </section>
  );
};

export default Products;
